import {useBoardRedux, useGetusersByBoardId, useRemoveUsersFromBoard} from 'hooks/board';
import {UserInviteScopeLevelEnum} from 'models';
import {UserListingResponseModel} from 'models/tenant.model';
import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {MembershipBaseSetting, MemberShipBaseSettingHandleComponent, userColumnsRelations} from 'views/settings/common';

export const BoardMemberSetting: React.FC = () => {
    const [data, setData] = useState<UserListingResponseModel[]>([]);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const {boardId} = useParams();
    const {selectedBoard} = useBoardRedux();

    const {usersByBoardId, usersByBoardIdLoading, usersByBoardIdResponse} = useGetusersByBoardId();

    const {removeUsersFromBoard, removeUsersFromBoardLoading, removeUsersFromBoardResponse} = useRemoveUsersFromBoard();

    const handleSelectAll = (checked: boolean, allIds: string[]) => {
        setIsAllSelected(checked);
        setSelectedIds(checked ? allIds : []);
    };

    const handleRowSelect = (checked: boolean, id: string) => {
        setSelectedIds(prev => (checked ? [...prev, id] : prev.filter(selectedId => selectedId !== id)));
    };

    const handleAllDelelte = (ids: string[]) => {
        setData(prev => prev.filter(x => !ids.includes(x.id)));
    };

    const removeUserHandler = () => {
        if (selectedBoard && selectedIds.length > 0) {
            removeUsersFromBoard({
                variables: {
                    request: {
                        boardId: selectedBoard.id,
                        userIds: selectedIds,
                    },
                },
            });
        }
    };
    const memberShipBaseRef = useRef<MemberShipBaseSettingHandleComponent>(null);
    const handleEmailInvite = (values: string) => {
        if (memberShipBaseRef.current) {
            memberShipBaseRef.current.handleInviteUserEmails([values]);
        }
    };
    const setIsDeleteAlertOpen = (val: boolean, id?: string) => {
        if (id) {
            setSelectedIds([id]);
        }
        if (memberShipBaseRef.current) {
            memberShipBaseRef.current.setAlertOpen(val);
        }
    };
    const columns = userColumnsRelations({
        selectedIds,
        isAllSelected,
        handleSelectAll,
        handleEmailInvite,
        handleRowSelect,
        setIsDeleteAlertOpen,
    });

    const handleRefreshData = () => {
        if (boardId) {
            usersByBoardId({
                variables: {
                    boardSlug: boardId,
                },
            });
        }
    };
    useEffect(() => {
        if (boardId) {
            usersByBoardId({
                variables: {
                    boardSlug: boardId,
                },
            });
        }
    }, [boardId]);

    useEffect(() => {
        if (!usersByBoardIdLoading && usersByBoardIdResponse) {
            setData(usersByBoardIdResponse.nodes);
        }
    }, [usersByBoardIdLoading, usersByBoardIdLoading]);

    useEffect(() => {
        if (!removeUsersFromBoardLoading && removeUsersFromBoardResponse) {
            handleAllDelelte(selectedIds);
            setIsDeleteAlertOpen(false);
            setSelectedIds([]);
        }
    }, [removeUsersFromBoardLoading, removeUsersFromBoardResponse]);
    if (!boardId || !selectedBoard) {
        return <></>;
    }
    return (
        <MembershipBaseSetting
            columns={columns}
            ref={memberShipBaseRef}
            handleRefreshData={handleRefreshData}
            data={data}
            scopeId={selectedBoard.id}
            scopeLevel={UserInviteScopeLevelEnum.Board}
            removeUserHandler={removeUserHandler}
            searchValue={searchValue}
            selectedIds={selectedIds}
            setSearchValue={setSearchValue}
        />
    );
};

export default BoardMemberSetting;
